<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button @click="skip" class="pill next-pill-button">
          <span>Skip</span>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
          <div class="auth-heading">
            <h1>Location</h1>
            <p class="auth-subtext">Enter your City and State</p>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
          </div>
        </div>
        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')">
        <!-- <div class="form_text">
          <div class="text">
            {{ pageText[userRole].formText }}
          </div>
        </div> -->
        <el-form-item class="no-scroll"  prop="address" :required="true">
          <div class="el-input el-input--prefix" :class="formsData.userForm.address.disabled ? 'is-disabled' : ''">

            <vue-google-suburb-autocomplete data-testid="directions-102" id="map" classname="el-input__inner"
              :ref="(el) => (formsData.userForm.address.ref = el)" v-model="formsData.userForm.address.value.text"
              :placeholder="pageText[userRole].inputPlaceholder" v-on:placechanged="setAddressData" @keyup="setAddress"
              :country="countryArray" :disabled="formsData.userForm.address.disabled">
            </vue-google-suburb-autocomplete>
            <span class="el-input__prefix"><i class="el-input__icon el-icon-search"></i></span>
          </div>
        </el-form-item>


        <el-form-item class="button_submit mb0">
          <el-button class="submit btn-primary" type="blue" data-testid="directions-103" @click="save('userForm')"
            :disabled="formsData.userForm.disabled">
            Continue
          </el-button>
        </el-form-item>
      </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  inject,
  computed
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
// import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import addressText from "@/helpers/address/address.js";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

import { VueGoogleSuburbAutocomplete } from "@/components/components";


export default {
  components: {
    // IonToolbar,
    // IonButton,
    // IonButtons,
    // IonIcon,
    SvgIcon,
    VueGoogleSuburbAutocomplete,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const googleMaps = inject(["googleMaps"]);

    const userData = $store.getters.GET_USER_DATA;
    console.log("🚀 ~ setup ~ userData:", userData)
    const userRole = userData.role;
    console.log(userData);

    const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });

    const pageText = {
      'job-seeker': {
        pageTitle: "Home Address",
        formText: "Start typing your home address and select it from the suggested list. We will use it to recommend opportunities near you. ",
        inputPlaceholder: "Find your address",
      },
    };

    const addressPageType =
      $route.name == "job-seeker";
    console.log("hshshssh");
    let address = {
      text: userData.billing.address.text || "",
    };


    let addressDisabled = ref(false);


    const formsDataArray = {
      userForm: {
        address: {
          value: address,
          valueTemp: "",
          disabled: addressDisabled.value,
          validators: [
            {
              validator: (rule, formField, callback) => {
                let addressValidationMessageFor = "address";
                if(userData.role === 'job-seeker') {
                  addressValidationMessageFor = "seekerAddress";
                }
                formValidate.validate(
                  rule,
                  formField,
                  addressValidationMessageFor,
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    const setAddress = () => {
      if (
        formsData.userForm.address.value.text !=
        formsData.userForm.address.value.temp
      ) {
        formsData.userForm.address.value.text = null;
      }
      checkFormValidation("userForm", true, "address");
    };

    const setAddressData = (addressData, placeResultData) => {
      formsData.userForm.address.value.text = placeResultData.formatted_address;
      console.log(placeResultData);
      formsData.userForm.address.ref.update(
        formsData.userForm.address.valueTemp
      );
      if (addressPageType !== "billingAddress") {
        (async () => {
          try {
            formsData.userForm.address.value.lat =
              addressData.latitude.toString();
            formsData.userForm.address.value.lng =
              addressData.longitude.toString();
            formsData.userForm.address.value.subpremise = (addressData.subpremise ? addressData.subpremise : "")
            formsData.userForm.address.value.street ="";
            formsData.userForm.address.value.state =
              addressData.administrative_area_level_1
                ? addressData.administrative_area_level_1
                : "";
            formsData.userForm.address.value.suburb = addressData.locality
              ? addressData.locality
              : "";
            formsData.userForm.address.value.country = addressData.country
              ? addressData.country
              : "";
            formsData.userForm.address.value.postcode = addressData.postal_code
              ? addressData.postal_code
              : "";

            formsData.userForm.address.value.text =
              placeResultData.formatted_address;
            formsData.userForm.address.value.temp =
              placeResultData.formatted_address;
            formsData.userForm.address.ref.update(
              formsData.userForm.address.value.text
            );
            const timezone = await googleMaps.getTimeZone(
              formsData.userForm.address.value.lat +
              "," +
              formsData.userForm.address.value.lng
            );
            formsData.userForm.address.value.timezone = timezone.timeZoneId;

            console.log(formsData.userForm.address.value);
          } catch (error) {
            console.log(error);
          }
        })();
      }
      checkFormValidation("userForm", true, "address");
    };


    const onAddressCheckboxChange = () => {
      if (formsData.userForm.address.disabled) {
        formsData.userForm.address.valueTemp =
          formsData.userForm.address.value.text;
        formsData.userForm.address.value.text = addressText(userData.address);
        formsData.userForm.address.ref.update(addressText(userData.address));
        formsData.userForm.address.disabled = true;

        formsData.userForm.shop_number.valueTemp =
          formsData.userForm.shop_number.value;
        formsData.userForm.shop_number.value = userData.address.shopNumber;

        formsData.userForm.shop_number.disabled = true;
        console.log(true);
      } else {
        formsData.userForm.address.value.text =
          formsData.userForm.address.valueTemp;
        formsData.userForm.address.ref.update(
          formsData.userForm.address.valueTemp
        );
        formsData.userForm.shop_number.value =
          formsData.userForm.shop_number.valueTemp;
        formsData.userForm.shop_number.disabled = false;
        formsData.userForm.address.disabled = false;
        console.log(false);
      }
      checkFormValidation("userForm", true, "address");
    };

    const goBack = async() => {
      const back = await $store.dispatch("getAuthPageBack");
      $router.push({
        name: back,
      });
    };

    const goNext = () => {
      $router.push({
        name: "jobseeker_auth_level",
      });
    };

    const save = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              let data = getFormValues(formName);

              await $store.dispatch("SAVE_JOB_SEEKER_ADDRESS", data);
              goNext();
            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };


    onMounted(() => {
      setPageClassGlobal("global_auth_page");
      setFormRefs();
      formsData.userForm.address.ref.update(
        formsData.userForm.address.value.text
      );
      delete formsData.userForm.billing_email.validators;
      checkFormValidation("userForm", false);
    });

    const skip = () => {
      (async () => {
       
        try {
          await $store.dispatch("addAuthPageBack", $route.name);
          goNext();
        } catch (error) {
          console.log(error);
        }
      })();
    };

    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      userData,
      formsData,
      goBack,
      save,
      setAddressData,
      setAddress,
      onAddressCheckboxChange,
      pageText,
      addressPageType,
      userRole,
      countryArray,
      skip
    };
  },
};
</script>
